import { apiClient } from './apiClient';

export interface InquiryPayload {
  name: string;
  email: string;
  brand?: string;
  phone?: string;
  category?: string;
  brief: string;
}

export interface SubmitInquiryResult {
  success: boolean;
  error?: string;
}

// Sends a creative-collaboration inquiry from the 关于我们 page. The backend
// forwards it as an email to the studio inbox. Public endpoint — no auth needed,
// so we suppress the auth prompt on failure.
export async function submitInquiry(payload: InquiryPayload): Promise<SubmitInquiryResult> {
  const response = await apiClient.post<{ success: boolean; error?: string }>(
    '/api/v1/inquiries',
    payload,
    undefined,
    { suppressAuthPrompt: true }
  );

  if (response.success && response.data?.success) {
    return { success: true };
  }
  return { success: false, error: response.data?.error || response.error || '提交失败，请稍后再试' };
}
